module.exports = __webpack_public_path__ + "img/Vorhersage.e44018d5.png";